import React from 'react';

export const AdultsOnlyCurvedPositionIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14 47.16C16.6731 47.16 18.84 44.993 18.84 42.32C18.84 39.6469 16.6731 37.48 14 37.48C11.327 37.48 9.16003 39.6469 9.16003 42.32C9.16003 44.993 11.327 47.16 14 47.16Z"
        fill="#FF6AA0"
      />
      <path
        d="M14 31.68C16.6731 31.68 18.84 29.5131 18.84 26.84C18.84 24.1669 16.6731 22 14 22C11.327 22 9.16003 24.1669 9.16003 26.84C9.16003 29.5131 11.327 31.68 14 31.68Z"
        fill="#00A6ED"
      />
      <path
        d="M52.22 46.8C49.78 46.42 47.24 44.84 45.62 42.9C44.12 41.14 42.98 39 42 36.9C42.2 34.54 41.44 31.94 39.36 29.28C36.58 25.4 30.84 24.8 27.1 23.64C26.52 23.46 25.94 23.16 25.36 22.78C32.6 18.94 42.7 20 46.8 28.12C50.58 35.72 49.2 42.18 58.96 44.66C61.72 46.9 53.64 47.24 52.22 46.8Z"
        fill="#00A6ED"
      />
      <path
        d="M19.2199 16.54C21.5199 20.04 23.8999 23.14 26.6799 24.28C30.2999 25.74 35.8799 26.12 38.5999 29.92C47.2599 41.12 30.7599 50.38 21.0599 46.24C20.3399 45.94 20.4199 44.84 21.1599 44.64C25.6799 42.8 31.0399 40.48 32.9799 36.6C33.0399 36.3 33.0199 36.22 32.9799 35.98C32.3799 34.36 31.5599 33.72 29.2399 32.68C25.3799 31.4 20.2999 27.64 19.2799 23.24C18.8599 22.3 17.5199 15.26 19.2199 16.56V16.54Z"
        fill="#FF6AA0"
      />
    </svg>
  );
};
